<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@addNewPromotion">Add New Promotion</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label="@@closeDialogIcon" aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <form [formGroup]="addPromotionForm">
    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline" style="display: none">
        <mat-label i18n="@@promotionPercentLabel">Promotion percent</mat-label>
        <input matInput id="percent" placeholder="Promotion percent" name="percent" formControlName="percent" value="100" />
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@codesNumberLabel">Number of promotion codes</mat-label>
        <input data-testid="promotions_count" (keypress)="numberOnly($event)" matInput id="codesNumber" i18n-placeholder="@@codesNumberPlaceholder" placeholder="Number of promotion codes" name="codesNumber" formControlName="codesNumber" required i18n-aria-label="@@codesNumberInput" aria-label="Number of promotion codes"/>
        <mat-error>
          @if (!addPromotionForm.get('codesNumber').valid && addPromotionForm.get('codesNumber').touched) {
            @if (addPromotionForm.get('codesNumber').errors && addPromotionForm.get('codesNumber').errors['required']) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
            @if (addPromotionForm.get('codesNumber').errors && addPromotionForm.get('codesNumber').errors['min']) {
              <span i18n="@@minCodesError">At least one code is required.</span>
            }
            @if (addPromotionForm.get('codesNumber').errors && addPromotionForm.get('codesNumber').errors['max']) {
              <span i18n="@@maxCodesError">A maximum of 100 codes is allowed.</span>
            }
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@expireDateLabel">Expire date</mat-label>
        <input [min]="minDate" data-testid="expire_date" id="expireDate" name="expireDate" formControlName="expireDate" required matInput [matDatepicker]="picker" i18n-aria-label="@@expireDateInput" aria-label="Expire date">
        <mat-datepicker-toggle matSuffix [for]="picker" i18n-aria-label="@@datePickerToggle" aria-label="Toggle date picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error>
          @if (!addPromotionForm.get('expireDate').valid && addPromotionForm.get('expireDate').touched) {
            @if (addPromotionForm.get('expireDate').errors && addPromotionForm.get('expireDate').errors['required']) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
          @if (!addPromotionForm.get('expireDate').valid && addPromotionForm.get('expireDate').touched) {
            @if (addPromotionForm.get('expireDate').errors && addPromotionForm.get('expireDate').errors['matDatepickerMin']) {
              <span i18n="@@pastDateError">Date can't be in past!</span>
            }
          }
        </mat-error>
      </mat-form-field>
    </div>
    <div>
      <button i18n="@@add" data-testid="add_promotions_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()" i18n-aria-label="@@addPromotionButton" aria-label="Add Promotion">Add</button>
    </div>
  </form>
</mat-dialog-content>